<template>
  <div>
    <h1>Blocked Phone numbers</h1>

    <div class="border small-padding flex full-width">
      <div class="flex-basis">
        <div class="flex">
          <MaterialText v-model="phone" label="Phone" />
        </div>
        <div class="margin-top">
          <MaterialDropdown label="Country" :options="countries" v-model="country_id" />
        </div>
        <div>
          <button v-on:click="createBlockedPhone()" class="small-margin-top" :disabled="saving">
            Create blocked address
          </button>
        </div>
      </div>
    </div>
    <div class="margin-top">
      <Table class="margin-top" :rows="list" :columns="columns" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  name: 'BlockedPhone',
  data: () => ({
    loading: false,
    blockedList: [],
    phone: '',
    country_id: '',
    saving: false,
    columns: {
      id: {
        name: 'ID'
      },
      phone: {
        name: 'Phone'
      },
      country_id: {
        name: 'Country',
        type: 'flag'
      },
      blocked: {
        name: 'Blocked'
      }
    }
  }),
  computed: {
    ...mapGetters([
      'getCountries'
    ]),
    countries () {
      return Vue.$array.keyValue(this.getCountries, 'id', 'name')
    },
    list () {
      const blockedList = []
      for (var i in this.blockedList) {
        const blocked = this.blockedList[i]
        blocked.blocked = !blocked.unblocked
        blocked.menu = [
          {
            name: 'Delete',
            onClick: (row) => {
              this.deleteBlockedPhone(row)
            }
          }
        ]
        const unblockButton = {
          name: 'Unblock',
          onClick: (row) => {
            this.unblockPhone(row)
          }
        }
        const blockButton = {
          name: 'Block',
          onClick: (row) => {
            this.blockPhone(row)
          }
        }
        if (blocked.unblocked) {
          blocked.menu.push(blockButton)
        } else {
          blocked.menu.push(unblockButton)
        }
        blockedList.push(blocked)
      }
      return blockedList
    }
  },
  methods: {
    getList () {
      Vue.$api.get('/phone/blocked/list', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: (data) => {
          this.blockedList = data
        }
      })
    },
    createBlockedPhone () {
      Vue.$api.post('/phone/blocked/store', {
        phone: this.phone,
        country_id: this.country_id
      }, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: (data) => this.$router.go(0)
      })
    },
    deleteBlockedPhone (row) {
      Vue.$api.delete('/phone/blocked/' + row.id + '/delete', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: (data) => this.$router.go(0)
      })
    },
    unblockPhone (row) {
      Vue.$api.post('/phone/blocked/' + row.id + '/unblock', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: (data) => this.$router.go(0)
      })
    },
    blockPhone (row) {
      Vue.$api.post('/phone/blocked/' + row.id + '/block', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: (data) => this.$router.go(0)
      })
    }
  },
  created () {
    this.getList()
  }
}
</script>

<style scoped>

</style>
